import React, { FC } from "react";
import { Card, Col, Row, Spin } from "antd";
import moment from "moment";

import useHttpGet from "../../hooks/useHttpGet";
import { APIRoutes } from "../../http";
import { INews } from "../../models/news.model";
import { Link } from "react-router-dom";
import { UIRoutes } from "../../router";
import { IResultListResponse } from "../../models/response/result-list.model";
import CommonService from "../../services/common.service";

interface IProps {
  name: string;
}

const InstrumentNews: FC<IProps> = ({ name }) => {
  const { fetchedData, loading } = useHttpGet<IResultListResponse<INews>>(
    `${APIRoutes.NEWS}`,
    {
      dependencies: [name],
      defaultValue: { result: [] },
      query: {
        Search: name,
      },
      condition: !!name,
    }
  );

  return (
    <Spin spinning={loading}>
      <div className="news">
        <h3 className="mt-2">LATEST NEWS ABOUT</h3>

        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          {fetchedData.result?.list?.map((el: INews) => (
            <Col xs={24} sm={12} md={8} key={el.id}>
              <Card
                title={
                  <Link
                    to={`/${
                      UIRoutes.VIEW_NEWS_BASE
                    }/${CommonService.replaceSymbol(el.title)}/${el.id}`}
                  >
                    {el.title}
                  </Link>
                }
                actions={[<span>{moment(el.createdOn).format("LLLL")}</span>]}
                className="mb-1 custom-card-1"
                key={el.id}
                bordered={false}
              >
                <div
                  dangerouslySetInnerHTML={{ __html: el.shortDescription }}
                  className="pt-0_5"
                />
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </Spin>
  );
};

export default InstrumentNews;
